module.exports = __webpack_public_path__ + "img/en.5a66d32e.svg";